var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5017 3.44254C21.8096 3.71963 21.8346 4.19385 21.5575 4.50173L19.7575 6.50173C19.6152 6.65977 19.4126 6.75001 19.2 6.75001H15.7017L14.9545 17.9569C14.8718 19.1979 15.8561 20.25 17.0999 20.25C18.2874 20.25 19.25 19.2874 19.25 18.0999V17C19.25 16.5858 19.5858 16.25 20 16.25C20.4142 16.25 20.75 16.5858 20.75 17V18.0999C20.75 20.1158 19.1158 21.75 17.0999 21.75C14.9884 21.75 13.3174 19.9639 13.4579 17.8571L14.1983 6.75001H10.6787L9.60648 17.4726C9.36366 19.9009 7.32038 21.75 4.88006 21.75H3.50001C3.08579 21.75 2.75001 21.4142 2.75001 21C2.75001 20.5858 3.08579 20.25 3.50001 20.25H4.88006C6.54975 20.25 7.94779 18.9848 8.11393 17.3234L9.17127 6.75001H6.93403L3.55748 10.5017C3.28038 10.8096 2.80617 10.8346 2.49828 10.5575C2.1904 10.2804 2.16544 9.80617 2.44254 9.49828L6.04254 5.49828C6.18477 5.34025 6.38739 5.25001 6.60001 5.25001H9.98992C9.99603 5.24993 10.0022 5.24993 10.0083 5.25001H18.866L20.4425 3.49828C20.7196 3.1904 21.1938 3.16544 21.5017 3.44254Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPi);
export default __webpack_public_path__ + "static/media/pi.132cdd118009d203a9ff4aefa25d7e6a.svg";
export { ForwardRef as ReactComponent };